export default __webpack_public_path__ + "static/media/b2.9774d3c7.jpg";